import React, {Component} from 'react';
import {observer, inject} from 'mobx-react';
import {SlideToggle} from 'react-slide-toggle';
import SideNav, {Nav, NavText} from 'react-sidenav';
import Button from '../../../../components/Button';

import './MapButtons.css';

@inject("appStore")
@observer
class MapButtons extends Component {

    toMapPos = (viewport) => {
        this.props.appStore.setMapViewport({
            center: {
                lat: viewport.center[0],
                lng: viewport.center[1]
            },
            zoom: viewport.zoom
        });
        //this.props.appStore.map.element.setView(campusLoc.center, campusLoc.zoom);
    };

    zoomAction = (id, parent) => {
        if (this.props.appStore.isMobile) {
            this.props.appStore.toggleMBIconClick();
        }
        //USE these lines to establish zooms
        let viewport = this.props.appStore.map.viewport;
        //console.log(`if (id === '${id}') this.toMapPos({center: [${viewport.center.lat}, ${viewport.center.lng}], zoom: ${viewport.zoom}}); `);

        if (this.props.appStore.isMobile) {
            if (id === 'seventh') this.toMapPos({center: [-0.4607341702560447, 0.31791687011718756], zoom: 10});
            if (id === 'sixth') this.toMapPos({center: [-0.7916770781725933, 0.31791687011718756], zoom: 10});
            if (id === 'fifth') this.toMapPos({center: [-1.1212205463686813, 0.31791687011718756], zoom: 10});
            if (id === 'fourth') this.toMapPos({center: [-1.5859485629127588, 0.45181274414062506], zoom: 9});
            if (id === 'third') this.toMapPos({center: [-2.027927287901161, 0.454559326171875], zoom: 9});
            if (id === 'second') this.toMapPos({center: [-2.4670412895880314, 0.454559326171875], zoom: 9});
            if (id === 'first') this.toMapPos({center: [-3.125432480854335, 0.45730590820312506], zoom: 9});
            if (id === 'concourse') this.toMapPos({center: [-3.5312401036034915, 0.46554565429687506], zoom: 9});
        } else {
            if (id === 'concourse') this.toMapPos({center: [-3.367429183298769, 0.454559326171875], zoom: 10});
            if (id === 'first') this.toMapPos({center: [-3.038354632009122, 0.454559326171875], zoom: 10});
            if (id === 'second') this.toMapPos({center: [-2.4896793962455, 0.454559326171875], zoom: 10});
            if (id === 'third') this.toMapPos({center: [-2.050572239036836, 0.454559326171875], zoom: 10});
            if (id === 'fourth') this.toMapPos({center: [-1.7211613677005735, 0.454559326171875], zoom: 10});
            if (id === 'fifth') this.toMapPos({center: [-1.1819763969044004, 0.36529541015625006], zoom: 11});
            if (id === 'sixth') this.toMapPos({center: [-0.8524389481865617, 0.36529541015625006], zoom: 11});
            if (id === 'seventh') this.toMapPos({center: [-0.5228732964507028, 0.36529541015625006], zoom: 11});
        }

    };

    mobileIconClicked = () => {
        this.props.appStore.toggleMBIconClick();
    };

    changeBGColor = () => {
        if (this.props.appStore.isMBIconClicked) {
            return {backgroundColor: '#bfbfbf'};
        } else {
            return {};
        }
    };

    getInnerSideNav = () => {
        //TODO replace the SideNav library as it generates unusable CSS styles
        return (
            <div className="innerSideNav">
                <div className="zoom-to"><i className="far fa-compass"/><p>Zoom to Location</p></div>
                <SideNav highlightColor='#3a3a3a' highlightBgColor='#bfbfbf' hoverBgColor='#eae6e6'
                         defaultSelected='druid_hills'
                         onItemSelection={(id, parent) => {
                             this.zoomAction(id);
                         }}>
                    <Nav id='seventh'>
                        <NavText>Seventh Floor</NavText>
                    </Nav>
                    <Nav id='sixth'>
                        <NavText>Sixth Floor</NavText>
                    </Nav>
                    <Nav id='fifth'>
                        <NavText>Fifth Floor</NavText>
                    </Nav>
                    <Nav id='fourth'>
                        <NavText>Fourth Floor</NavText>
                    </Nav>
                    <Nav id='third'>
                        <NavText>Third Floor</NavText>
                    </Nav>
                    <Nav id='second'>
                        <NavText>Second Floor</NavText>
                    </Nav>
                    <Nav id='first'>
                        <NavText>First Floor</NavText>
                    </Nav>
                    <Nav id='concourse'>
                        <NavText>Concourse</NavText>
                    </Nav>
                </SideNav>
            </div>);
    };

    render() {
        if (this.props.appStore.isMobile) {
            return (
                <div className="MapButtonsM">
                    <div className="MBIcon">
                        <Button className='compassBtn' onClick={this.mobileIconClicked}
                                style={this.changeBGColor()}>
                            <i className="far fa-compass" aria-hidden="true"></i>
                        </Button>
                    </div>
                    {this.props.appStore.isMBIconClicked && this.getInnerSideNav()}
                </div>
            );
        } else {
            return (
                <div className="MapButtons">
                    {this.getInnerSideNav()}
                </div>
            );
        }

    }
}

export default MapButtons;





// WEBPACK FOOTER //
// ./src/scenes/MapContainer/components/MapButtons/index.js